<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Ingredients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect,Loader, },
  data() {
    return {
      title: "Ingredients",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Ingredients",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "recipe",
          sortable: true,
          label: "INGREDIENT",
        },
        {
          key: "recipe_qty",
          sortable: true,
          label: "INGREDIENT QUANTITY",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "product_qty",
          sortable: true,
          label: "PRODUCT QUANTITY",
        },        
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      filterdata: {
        product:"", 
      },
      // edit item
      editdata: {
        id: "",
        recipe: "",
        product: "",
        product_qty: "",
        recipe_qty: "",
      },
      // delete item
      deletedata: {
        recipe: "",
        product: "",
        id: "",
      },
      basedata:{
        recipe: "",
        product: "",
        product_id:"",
        id: "",
      },
      recipeQtyError:"",
      productQtyError:""
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("recipes", ["SaveStatus", "Recipes"]),
    ...mapGetters("auth",["MyUserPerm"]),
    ...mapGetters("products", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Recipes ? this.Recipes.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Recipes ? this.Recipes.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchRecipes: "recipes/fetchRecipes",
      FetchItems: "products/fetchProducts",
      DeleteRecipe: "recipes/deleteRecipes",
      EditRecipe: "recipes/editRecipes",
      ChangeBase: "recipes/changeBase",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });    
    },

    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.recipe = "";
      this.deletedata.product = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.product = "";
      this.editdata.recipe = "";
      this.editdata.id = "";
      this.editdata.recipe_qty = "";
      this.editdata.product_qty = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.recipeQtyError = "";
      this.productQtyError = "";
    },

    resetBase() {
      this.basedata.recipe = "";
      this.basedata.product = "";
      this.basedata.id = "";
      this.modal_id = "";
    },

    showEditModal(data) {
      this.editdata.product = data.product;
      this.editdata.recipe = data.recipe;
      this.editdata.id = data.id;
      this.editdata.product_qty = data.product_qty;
      this.editdata.recipe_qty = data.recipe_qty;
    },

    showDeleteModal(data) {
      this.deletedata.recipe = data.recipe;
      this.deletedata.product = data.product;
      this.deletedata.id = data.id;
    },

    showBaseModal(data) {
      this.basedata.recipe = data.recipe;
      this.basedata.product = data.product;
      this.basedata.product_id = data.product_id;
      this.basedata.id = data.id;
    },

    editItem(modalId) {
      this.modal_id = modalId;
      this.EditRecipe(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteRecipe(this.deletedata);
    },

    changeBase(modalId) {
      this.modal_id = modalId;
      this.ChangeBase(this.basedata);
    },

    getIngredients(){
      this.FetchRecipes(this.filterdata);
    },

  },
  created() {
    this.FetchRecipes(this.filterdata);
    this.FetchItems();
    this.addProduct();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-7">
              </div>            
              <div class="form-group col-md-5 mb-4">
                <label>Filter by Product</label>
                <model-list-select
                    :list="[...Products, { id: '', name: 'All Products' }]"
                    v-model="filterdata.product"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Product"
                    @input="getIngredients()"
                >
                </model-list-select>
              </div>
            </div>            
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->              
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="Recipes ? Recipes : []"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(recipe_qty)="data">
                  {{ data.item ? data.item.recipe_qty : 0 }} {{data.item.recipeunit}}
                </template>
                <template #cell(product_qty)="data">
                  {{ data.item ? data.item.product_qty : 0 }} {{data.item.productunit}}
                </template>

                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                        v-if="MyUserPerm.edit_ingredients"
                        size="sm"
                        variant="primary"
                        v-b-modal.edit-item-modal
                        @click="showEditModal(data.item)"
                    ><i class="fa fa-edit"></i></b-button>
                    <b-button
                        v-if="!data.item.is_base && MyUserPerm.delete_ingredients"
                        v-b-modal.delete-item-modal
                        variant="danger"
                        size="sm"
                        @click="showDeleteModal(data.item)"
                    ><i class="fa fa-trash"></i></b-button>
                    <b-button size="sm"
                      v-if="!data.item.is_base"
                      class="bg-soft"
                      v-b-modal.base-ingredient-modal
                      @click="showBaseModal(data.item)"
                      ><i class="fa fa-cog"></i> Set as Base
                    </b-button>
                  </b-button-group>
                </template>
              </b-table>

            <!-- modal change default ingredient starts -->
            <b-modal
              header-bg-variant="warning"
              header-text-variant="light"
              body-text-variant="warning"
              footer-bg-variant="warning"
              footer-text-variant="warning"
              id="base-ingredient-modal"
              hide-footer
              @hidden="resetBase()"
            >
              <template #modal-title> Set Ingredient <small><em>{{ basedata.recipe }}</em></small> as Base Ingredient</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to set Ingredient <small class="text-warning"><em>{{ basedata.recipe }}</em></small> as Base Ingredient for Product <small class="text-warning"><em>{{ basedata.product }}</em></small>? Click Proceed Button to continue.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('base-ingredient-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="changeBase('base-ingredient-modal')"
                >
                  <i class="fa fa-cog"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Changing"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal edit item starts -->
            <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()" class="text-primary">
              <template #modal-title>
                Edit Ingredient {{ editdata.recipe }} for product {{ editdata.product }}</template
              >
              <div class="form-group mb-3">
                <label>Ingredient Quantity</label>
                <input
                    type="number"
                    class="form-control"
                    step="any"
                    v-model="editdata.recipe_qty"
                />
              </div>
              <div class="form-group mb-3">
                <label>Product Quantity</label>
                <input
                    type="number"
                    class="form-control"
                    step="any"
                    v-model="editdata.product_qty"
                />
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('edit-item-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="editItem('edit-item-modal')"
                >
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- modal delete item starts -->
            <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem" class="text-danger">
              <template #modal-title> Delete ingredient {{ deletedata.recipe }} for product {{ deletedata.product }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to delete this ingredient? Click Proceed to continue.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-item-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteItem('delete-item-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!Recipes" />
          </div>
        </div>
      </div>
    </div>
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>